import React, { useState, useEffect } from "react";
import OnChangeInputField from "../../onChangeInputField/OnChangeInputField";
import "./AddForm.css";
import Button from "../../button/Button";
import axios from "axios";
import { apiUrl } from "../../../constants";
import DropZone from "../dropZone/DropZone";
import FunctionalButton from "../../button/FunctionalButton";

const AddForm = ({
  route,
  title,
  toggleShowFullList,
  toggleDisplayContainer,
  toggleReloadAll,
  toggleInsertForm,
}) => {
  const [success, toggleSuccess] = useState(false);
  const [insertedValue, setInsertedValue] = useState("");
  const [dataReady, toggleDataReady] = useState(false);
  const [displayInsertForm, toggleDisplayInsertForm] = useState(true);
  const [error, toggleError] = useState(false);
  const [errorMessage, toggleErrorMessage] = useState(false);
  const [loading, toggleLoading] = useState(false);
  const [databaseMessage, setDatabaseMessage] = useState("");
  const [file, setFile] = useState(null);
  const [errorMessageDropZone, setErrorMessageDropZone] = useState("");

  function handleChange(e) {
    toggleError(false);
    setInsertedValue(e.target.value);
  }

  function insert(e) {
    e.preventDefault();
    if (title !== "publisher" && insertedValue.length > 0) {
      toggleDataReady(true);
    } else if (title === "publisher" && file === null) {
      setErrorMessageDropZone("Image is required.");
    } else if (title === "publisher" && insertedValue.length < 0) {
      toggleError(true);
    } else if (
      title === "publisher" &&
      insertedValue.length > 0 &&
      file !== null
    ) {
      toggleDataReady(true);
    } else {
      toggleError(true);
    }
  }

  useEffect(() => {
    async function sendData() {
      toggleErrorMessage(false);
      toggleLoading(true);
      toggleSuccess(false);
      toggleDisplayInsertForm(false);
      const jwtToken = localStorage.getItem("token");
      if (title !== "publisher") {
        try {
          const result = await axios.post(
            `${apiUrl}/formsettings/${route}`,
            {
              [title]: insertedValue.trim(),
            },
            {
              headers: {
                Authorization: `Bearer ${jwtToken}`,
              },
            }
          );
          toggleDisplayInsertForm(false);
          toggleSuccess(true);
        } catch (e) {
          console.error(e);
          toggleErrorMessage(true);
          if (e.response !== undefined) {
            setDatabaseMessage(e.response.data.message);
          } else {
            setDatabaseMessage("Something went wrong. Please try again later.");
          }
        }
      } else {
        try {
          const newFileName =
            insertedValue.trim().split(" ").join("").toLocaleLowerCase() +
            "." +
            file.type.split("/")[1];

          const formData = new FormData();
          formData.append("file", file, newFileName);
          formData.append("publisher", insertedValue.trim());

          // verstuur ons formData object en geef in de header aan dat het om een form-data type gaat
          const result = await axios.post(
            `${apiUrl}/formsettings/${route}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${jwtToken}`,
              },
            }
          );
          toggleDisplayInsertForm(false);
          toggleSuccess(true);
        } catch (e) {
          console.error(e);
        }
      }

      toggleLoading(false);
    }

    if (dataReady) {
      sendData();
    }
  }, [dataReady]);

  function displayInstruction() {
    if (route === "subheadings") {
      return (
        <p className="message">Please add subheading in plural if possible.</p>
      );
    }
  }

  function returnToCompleteList() {
    toggleDisplayInsertForm(false);
    toggleShowFullList(true);
    toggleDisplayContainer(false);
    toggleReloadAll(true);
    toggleInsertForm(false);
  }

  return (
    <div className={"insert-settings-form-container"}>
      <div className={"form"}>
        {displayInsertForm && (
          <form onSubmit={insert}>
            <h4>Add new {title}</h4>
            <section>
              <OnChangeInputField
                label=""
                name={title}
                type="text"
                id="settings-field"
                onChange={(e) => handleChange(e, { title })}
                value={insertedValue}
              />
              {displayInstruction()}
              <div className={"error-wrapper"}>
                {error && (
                  <p className="error">
                    {title.charAt(0).toUpperCase() + title.slice(1)} is required
                  </p>
                )}
              </div>
            </section>

            {title === "publisher" && (
              <DropZone
                setFile={setFile}
                title={title}
                idItemToBeUpdated={""}
                errorMessageDropZone={errorMessageDropZone}
              />
            )}

            <div className="button-wrapper-add-settings-container">
              <section className="button-wrapper-add-settings">
                <Button type="submit">Submit</Button>
              </section>
            </div>
          </form>
        )}
        {loading && <p className="loading">Loading...</p>}
        {errorMessage && (
          <div className="error-section">
            <p>{databaseMessage}</p>
          </div>
        )}

        {success && (
          <section>
            <p className="success-message">
              {insertedValue} is inserted into the database.
            </p>
            <FunctionalButton
              handleClick={returnToCompleteList}
            >{`Return to ${title} list`}</FunctionalButton>
          </section>
        )}
      </div>
    </div>
  );
};

export default AddForm;
